import produce from 'immer';
import { LiveEventType } from 'store/pages/loaders/loader-types';
import {
  SHOW,
  HIDE,
  LOAD_EPG_SUCCESS,
  LOAD_EPG,
  LOAD_EPG_ERROR,
  LOAD_EXTRA_EPG,
  LOAD_EXTRA_EPG_SUCCESS,
  LOAD_EXTRA_EPG_ERROR,
} from './action-types';

export type EPGWIdgetStateType = {
  isVisible: boolean;
  isLoading: boolean;
  data: Record<string, LiveEventType[]>;
  error: null | string;
  updatedAt?: number;
};

const initialState: EPGWIdgetStateType = {
  isVisible: false,
  isLoading: false,
  data: {},
  error: null,
  updatedAt: null,
};

export default produce((draft: EPGWIdgetStateType, action) => {
  switch (action.type) {
    case SHOW:
      draft.isVisible = true;
      break;
    case HIDE:
      draft.isVisible = false;
      break;
    case LOAD_EPG: {
      draft.isLoading = true;
      break;
    }
    case LOAD_EPG_SUCCESS: {
      const { data, updatedAt } = action.payload;
      draft.isLoading = false;
      draft.data = { ...draft.data, ...data };
      draft.updatedAt = updatedAt;
      break;
    }
    case LOAD_EPG_ERROR: {
      draft.isLoading = false;
      draft.error = action.payload;
      break;
    }
    case LOAD_EXTRA_EPG: {
      draft.isLoading = true;
      break;
    }
    case LOAD_EXTRA_EPG_SUCCESS: {
      const { channelId, data } = action.payload;
      draft.isLoading = false;
      draft.data[channelId] = data;
      break;
    }
    case LOAD_EXTRA_EPG_ERROR: {
      draft.isLoading = false;
      draft.error = action.payload;
      break;
    }
    default:
    // nothing
  }
  return draft;
}, initialState);
